
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, Mail, Eye, EyeOff } from 'lucide-react';
import Button from '../../../components/base/Button';
import Input from '../../../components/base/Input';
import Card from '../../../components/base/Card';

export default function AdminLoginPage() {
  const [email, setEmail] = useState('admin@example.com');
  const [password, setPassword] = useState('password');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  
  useEffect(() => {
    // ログイン状態をクリアして確実にログインページを表示
    const isLoggedIn = localStorage.getItem('isAdminLoggedIn');
    if (isLoggedIn === 'true') {
      navigate('/admin/dashboard');
    }
  }, [navigate]);
  
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);
    
    try {
      // 入力値をトリムして比較
      const trimmedEmail = email.trim();
      const trimmedPassword = password.trim();
      
      console.log('ログイン試行:', { email: trimmedEmail, password: trimmedPassword });
      
      // 簡単な認証（実際のプロジェクトでは適切な認証を実装）
      if (trimmedEmail === 'admin@example.com' && trimmedPassword === 'password') {
        localStorage.setItem('isAdminLoggedIn', 'true');
        console.log('ログイン成功');
        navigate('/admin/dashboard');
      } else {
        setError('メールアドレスまたはパスワードが正しくありません');
        console.log('ログイン失敗');
      }
    } catch (err) {
      console.error('ログインエラー:', err);
      setError('ログイン処理中にエラーが発生しました');
    }
    
    setIsLoading(false);
  };

  // ログアウト機能（デバッグ用）
  const handleLogout = () => {
    localStorage.removeItem('isAdminLoggedIn');
    setError('');
    console.log('ログアウトしました');
  };
  
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">管理者ログイン</h1>
          <p className="text-sm text-gray-600">
            ボードゲーム管理システムにアクセス
          </p>
          <div className="mt-4 p-3 bg-blue-50 border border-blue-200 rounded-lg">
            <p className="text-sm text-blue-700">
              <strong>デモ用認証情報</strong><br />
              メール: admin@example.com<br />
              パスワード: password
            </p>
          </div>
        </div>
        
        <Card className="p-8">
          <form onSubmit={handleSubmit} className="space-y-6">
            <Input
              label="メールアドレス"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              icon={<Mail className="h-4 w-4 text-gray-400" />}
              placeholder="admin@example.com"
              required
            />
            
            <div className="relative">
              <Input
                label="パスワード"
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                icon={<Lock className="h-4 w-4 text-gray-400" />}
                placeholder="パスワードを入力"
                required
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-3 top-8 text-gray-400 hover:text-gray-600"
              >
                {showPassword ? (
                  <EyeOff className="h-4 w-4" />
                ) : (
                  <Eye className="h-4 w-4" />
                )}
              </button>
            </div>
            
            {error && (
              <div className="bg-red-50 border border-red-200 rounded-lg p-3">
                <p className="text-sm text-red-600">{error}</p>
              </div>
            )}
            
            <Button
              type="submit"
              className="w-full"
              disabled={isLoading}
            >
              {isLoading ? 'ログイン中...' : 'ログイン'}
            </Button>
          </form>

          {/* デバッグ用ログアウトボタン */}
          <div className="mt-4 pt-4 border-t border-gray-200">
            <button
              onClick={handleLogout}
              className="w-full text-sm text-gray-500 hover:text-gray-700 underline"
            >
              ログイン状態をリセット（デバッグ用）
            </button>
          </div>
        </Card>
        
        <div className="text-center">
          <button
            onClick={() => navigate('/')}
            className="text-sm text-gray-600 hover:text-gray-900 underline"
          >
            公開サイトに戻る
          </button>
        </div>
      </div>
    </div>
  );
}
